import React, { useState, useEffect, Fragment } from 'react';
import { apiRequest } from '../../../../services/adapters/kepegawaian/mutasiPegawaiService';
import { Card, CardBody, CardHeader, Button, Row, Col, Label, Container } from 'reactstrap';
import Select from 'react-select';
import { AvForm } from 'availity-reactstrap-validation';
import { Link, useHistory } from 'react-router-dom';
import { ConfirmAlert } from '../../../../helpers/ui/alert';

import FormPegawai from './Components/FormPegawai';
import FormPemberhentian from './Components/FormPemberhentian';
import FormPengangkatan from './Components/FormPengangkatan';

const CreateMutasiBaru = (props) => {
    const history = useHistory();
    const parentUuid = props.uuid;
    const queryParams = new URLSearchParams(props.location?.search || window.location?.search || "");
    const detailUuid = queryParams.get('detail_uuid');
    const backUrl = parentUuid ? `?updatemutasi=1&uuid=${parentUuid}` : `?`;

    const [formState, setFormState] = useState({
        type: null,
        stop_cause: null,
        employee_uuid: null,
        employee_status_uuid: null,
        selectedEmployee: null
    });

    const [typeCache, setTypeCache] = useState({});
    
    const [alertState, setAlertState] = useState({
        confirm: false,
        loading: true,
        loadingTitle: "Memuat Data...",
        loadingInfo: "Sedang mengambil data master, mohon tunggu sebentar.",
        success: false,
        failed: false,
        failedInfo: ''
    });

    const [masterData, setMasterData] = useState({
        transferTypes: [],
        stopCauses: [],
        employees: [],
        regions: [],
        legalPositions: [],
        educationMajors: [],
        ministries: [],
        assignmentTypes: [],
        employeeStatuses: [],
        positionTypes: [],
        workUnits: [],
        positions: []
    });

    // Fetch master data directly from the newly created controller
    useEffect(() => {
        const fetchMaster = async () => {
            try {
                const params = parentUuid ? { parent_uuid: parentUuid } : null;
                const response = await apiRequest("get", "Kepegawaian/MutasiBaru/getMasterData/", { params });
                if (response.response) {
                    const regionsData = response.response.regions || [];
                    
                    setMasterData(prev => ({
                        ...prev,
                        existingEmployeeUuids: response.response.existingEmployeeUuids || [],
                        transferTypes: response.response.transferTypes || [],
                        stopCauses: response.response.stopCauses || [],
                        employees: response.response.employees || [],
                        regions: regionsData,
                        legalPositions: response.response.legalPositions || [],
                        educationMajors: response.response.educationMajors || [],
                        ministries: response.response.ministries || [],
                        assignmentTypes: response.response.assignmentTypes || [],
                        positionTypes: response.response.positionTypes || [],
                        workUnits: response.response.workUnits || [],
                        positions: response.response.positions || [],
                        employeeCategories: response.response.employeeCategories || [],
                        employeeStatuses: response.response.employeeStatuses || []
                    }));

                    const localRegion = regionsData.find(r => r.region_is_local == 1);
                    if (localRegion) {
                        setFormState(prev => ({
                            ...prev,
                            employee_transfer_detail_country_uuid: prev.employee_transfer_detail_country_uuid || localRegion.value
                        }));
                    }
                    
                    if (detailUuid) {
                        try {
                            const detailRes = await apiRequest("get", "Kepegawaian/MutasiBaru/detailMutasi/", { params: { uuid: detailUuid } });
                            if (detailRes && detailRes.response) {
                                const detailData = detailRes.response;
                                const emp = response.response.employees ? response.response.employees.find(e => e.value === detailData.employee_transfer_detail_employee_uuid) : null;
                                
                                let isBaru = false;
                                if (emp && (emp.employee_current_position_name === null || emp.employee_status_name === null)) {
                                    isBaru = true;
                                }
                                
                                setFormState(prev => ({
                                    ...prev,
                                    ...detailData,
                                    type: parseInt(detailData.employee_transfer_detail_type) || null,
                                    employee_uuid: detailData.employee_transfer_detail_employee_uuid,
                                    employee_status_uuid: detailData.employee_transfer_detail_employee_status_uuid,
                                    stop_cause: detailData.employee_transfer_detail_stop_cause,
                                    isUpdate: true,
                                    ...detailData,
                                    employee_internal_type: isBaru ? 'baru' : 'lama',
                                    selectedEmployee: emp,
                                    new_employee_nip: detailData.emp_nip || '',
                                    new_employee_name: detailData.emp_name || '',
                                    employee_categories_uuid: detailData.emp_cat_uuid || '',
                                    autoFillSignal: isBaru ? Date.now() : prev.autoFillSignal
                                }));
                            }
                        } catch(err) {
                            console.error("Failed to fetch detail mutasi", err);
                        }
                    }
                }
            } catch (err) {
                console.error("Failed to fetch master data", err);
            } finally {
                setAlertState(prev => ({ ...prev, loading: false }));
            }
        };
        fetchMaster();
    }, []);

    const handleSubmit = (event, errors, values) => {
        if (errors.length === 0) {
            setFormState(prev => ({ ...prev, ...values }));
            setAlertState(prev => ({ ...prev, confirm: true }));
        } else {
            setTimeout(() => {
                const errorElements = document.querySelectorAll('.is-invalid, .invalid-feedback');
                let target = null;
                for (let el of errorElements) {
                    if (el.classList.contains('d-none') || el.clientHeight === 0 || window.getComputedStyle(el).display === 'none') {
                        const parentGroup = el.closest('.form-group, .mb-2, .row');
                        if (parentGroup && parentGroup.clientHeight > 0) {
                            target = parentGroup;
                            break;
                        }
                    } else {
                        target = el;
                        break;
                    }
                }
                
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 100);
        }
    };

    const confirmResponse = async (response) => {
        let newState = { confirm: false, loading: false, success: false, failed: false };
        if (response === 'cancel') {
            setAlertState(prev => ({ ...prev, confirm: false }));
        } else if (response === 'confirm') {
            setAlertState(prev => ({ ...prev, confirm: false, loading: true, loadingTitle: "Mengirim data...", loadingInfo: "Tunggu beberapa saat" }));
            try {
                // If there's a uuid in the URL, we might want to pass it to the backend. 
                // But since the backend currently creates a new parent transfer, we just get the newly generated parent UUID.
                
                const submitData = { ...formState };
                if (detailUuid) {
                    submitData.employee_transfer_detail_uuid = detailUuid;
                    submitData.isUpdate = true;
                }
                const res = await apiRequest("post", "Kepegawaian/MutasiBaru/storejson/", { body: submitData });

                if (res.status === 200 || res.status === 201 || res.status === true || (res.response && res.response.status)) {
                    // Extract the parent UUID generated by backend
                    const parentUuid = res.response?.employee_transfer_detail_parent_uuid || '';
                    setAlertState(prev => ({ ...prev, loading: false, success: true, redirectUuid: parentUuid }));
                } else {
                    setAlertState(prev => ({ ...prev, loading: false, failed: true, failedInfo: res.message || 'Data gagal disimpan' }));
                }
            } catch (err) {
                setAlertState(prev => ({ ...prev, loading: false, failed: true, failedInfo: 'Terjadi kesalahan pada server' }));
            }
        } else if (response === 'success') {
            const redirectUuid = alertState.redirectUuid;
            setAlertState(prev => ({ ...prev, success: false }));
            
            // Redirect to update mutasi page using the parent UUID without full reload
            if (redirectUuid) {
                history.push(`?updatemutasi=1&uuid=${redirectUuid}`);
            } else {
                history.push('?');
            }
        } else if (response === 'failed') {
            setAlertState(prev => ({ ...prev, failed: false }));
        }
    };

    const fillDefaultData = () => {
        setFormState(prev => ({
            ...prev,
            employee_transfer_detail_decree_number: prev.employee_transfer_detail_decree_number || 'SK-12345/2026',
            employee_transfer_detail_decree_date: prev.employee_transfer_detail_decree_date || '2026-09-23',
            employee_transfer_detail_study_assignment_number: prev.employee_transfer_detail_study_assignment_number || 'ST-9999/2026',
            employee_transfer_detail_study_assignment_date: prev.employee_transfer_detail_study_assignment_date || '2026-09-23',
            employee_transfer_detail_bkn_tech_consideration_number: prev.employee_transfer_detail_bkn_tech_consideration_number || 'BKN-5555/2026',
            employee_transfer_detail_bkn_tech_consideration_date: prev.employee_transfer_detail_bkn_tech_consideration_date || '2026-09-23',
            new_employee_nip: prev.new_employee_nip || '199001012026011001',
            new_employee_name: prev.new_employee_name || 'Budi Pegawai Baru',
            employee_transfer_detail_tmt_date_start: prev.employee_transfer_detail_tmt_date_start || '2026-09-23',
            employee_transfer_detail_tmt_date_end: prev.employee_transfer_detail_tmt_date_end || '2027-09-23',
            employee_transfer_detail_tmt_date: prev.employee_transfer_detail_tmt_date || '2026-09-23',
            employee_transfer_detail_spp_date: prev.employee_transfer_detail_spp_date || '2026-09-23',
            employee_transfer_detail_spmj_date: prev.employee_transfer_detail_spmj_date || '2026-09-23',
            employee_transfer_detail_spmt_date: prev.employee_transfer_detail_spmt_date || '2026-09-23',
            employee_transfer_detail_start_date: prev.employee_transfer_detail_start_date || '2026-09-23',
            employee_transfer_detail_end_date: prev.employee_transfer_detail_end_date || '2027-09-23',
            employee_transfer_detail_study_campus_name: prev.employee_transfer_detail_study_campus_name || 'Universitas Indonesia',
            employee_transfer_detail_education_level: prev.employee_transfer_detail_education_level || 'S-2',
            employee_transfer_detail_education_accreditation: prev.employee_transfer_detail_education_accreditation || 'A',
            employee_transfer_detail_education_title: prev.employee_transfer_detail_education_title || 'M.Sc',
            employee_transfer_detail_signatories_official: prev.employee_transfer_detail_signatories_official || 'Menteri Investasi',
            employee_transfer_detail_location: prev.employee_transfer_detail_location || 'Jakarta',
            employee_transfer_detail_stop_cause_reason: prev.employee_transfer_detail_stop_cause_reason || 'Lainnya',
            employee_transfer_detail_legal_position_status_uuid: prev.employee_transfer_detail_legal_position_status_uuid || (masterData.legalPositions.length > 0 ? masterData.legalPositions[0].value : ''),
            autoFillSignal: Date.now()
        }));
    };

    return (
        <Fragment>
            <Container fluid>
                <Row>
                <Col md={12}>
                    <Card>
                        <CardHeader>
                            <h4 className="card-title m-0">{detailUuid ? "Ubah Data Mutasi Pegawai Baru" : "Tambah Data Mutasi Pegawai Baru"}</h4>
                        </CardHeader>
                        <CardBody>
                            <AvForm onSubmit={handleSubmit} model={formState}>
                                <div className="mb-2">
                                    <Label className="font-weight-bold">Jenis Mutasi <span className="text-danger">*</span></Label>
                                    <Select
                                        options={masterData.transferTypes}
                                        value={masterData.transferTypes.find(opt => opt.value === formState.type)}
                                        onChange={(e) => {
                                            const newType = e.value;
                                            const oldType = formState.type;
                                            
                                            let newCache = { ...typeCache };
                                            if (oldType) {
                                                newCache[oldType] = { ...formState };
                                            }
                                            setTypeCache(newCache);
                                            
                                            const cachedState = newCache[newType] || {
                                                employee_uuid: null,
                                                employee_status_uuid: null,
                                                selectedEmployee: null,
                                                stop_cause: null
                                            };
                                            
                                            // Make sure the default is set
                                            if (!cachedState.employee_transfer_detail_country_uuid && masterData.regions) {
                                                const localRegion = masterData.regions.find(r => r.region_is_local == 1);
                                                if (localRegion) {
                                                    cachedState.employee_transfer_detail_country_uuid = localRegion.value;
                                                }
                                            }
                                            
                                            setFormState({ 
                                                ...cachedState, 
                                                type: newType 
                                            });
                                        }}
                                        placeholder="Pilih Jenis Mutasi"
                                        classNamePrefix="react-select"
                                    />
                                </div>
                                {formState.type && (
                                    <div className="border p-4 mb-4 bg-white shadow-sm" style={{ borderRadius: '8px' }}>
                                        <FormPegawai formState={formState} setFormState={setFormState} masterData={masterData} setAlertState={setAlertState} />
                                        <FormPemberhentian formState={formState} setFormState={setFormState} masterData={masterData} />
                                        <FormPengangkatan formState={formState} setFormState={setFormState} masterData={masterData} />
                                    </div>
                                )}

                                <div className="mt-4 pt-3 border-top d-flex" style={{ gap: '15px' }}>
                                    {formState.type && (
                                        <Button color="success" type="submit" style={{ minWidth: '120px' }}>
                                            <i className="nc-icon nc-check-2 mr-2"></i> Simpan
                                        </Button>
                                    )}
                                    <Link to={backUrl}>
                                        <Button color="danger" style={{ minWidth: '120px' }}>
                                            <i className="nc-icon nc-simple-remove mr-2"></i> Batal
                                        </Button>
                                    </Link>
                                    
                                    {formState.type && (
                                        <Button type="button" color="info" outline style={{ minWidth: '120px' }} onClick={fillDefaultData}>
                                            <i className="nc-icon nc-magic-wand mr-2"></i> Isi Default
                                        </Button>
                                    )}
                                </div>
                            </AvForm>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            </Container>
            
            <ConfirmAlert
                confirmTitle="Konfirmasi!"
                confirmInfo="Apakah anda yakin data tersebut sudah benar?"
                loadingTitle={alertState.loadingTitle || "Mengirim data..."}
                loadingInfo={alertState.loadingInfo || "Tunggu beberapa saat"}
                successTitle="Berhasil!"
                successInfo="Data berhasil disimpan"
                failedTitle="Gagal!"
                failedInfo={alertState.failedInfo || "Data gagal disimpan"}
                showConfirm={alertState.confirm}
                showLoading={alertState.loading}
                showSuccess={alertState.success}
                showFailed={alertState.failed}
                response={confirmResponse}
            />
        </Fragment>
    );
};

export default CreateMutasiBaru;
